<script setup>
import { ref } from "vue";

import Banner from "@/Components/Banner.vue";
import DashboardNavigation from "@/Components/Nav/DashboardNavigation.vue";
import FloatingBee from "@/Components/FloatingBee.vue";

const navigation_collapsed = ref(false);

const toggle_navigation_collapse = (value) => {
  navigation_collapsed.value = value;
};
</script>

<template>
  <div class="dashboard-layout">
    <Banner />
    <FloatingBee />

    <div class="body">
      <DashboardNavigation @collapse:navigation="toggle_navigation_collapse" />
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.body {
  background-color: var(--clr-bg-primary);
  display: flex;
  min-height: 100vh;
  max-width: 100%;
}

.dashboard-layout {
  min-height: 100vh;
  max-width: 100%;
}
</style>
